// services/gallery.service.js
import { collection, query, where, orderBy, getDocs } from "firebase/firestore";
import { ref, getDownloadURL } from "firebase/storage";
import { db, storage } from "../config/firebase";

export const galleryService = {
	// Get all active topics
	getGalleryTopics: async () => {
		try {
			const q = query(
				collection(db, "galleryTopics"),
				where("active", "==", true),
				orderBy("order", "asc")
			);

			const snapshot = await getDocs(q);
			return snapshot.docs.map((doc) => ({
				id: doc.id,
				...doc.data(),
			}));
		} catch (error) {
			console.error("Error fetching gallery topics:", error);
			throw error;
		}
	},

	// Get photos by topic
	getPhotosByTopic: async (topicId) => {
		try {
			const q = query(
				collection(db, "galleryPhotos"),
				where("topic", "==", topicId),
				orderBy("order", "asc")
			);

			const snapshot = await getDocs(q);
			const photos = snapshot.docs.map((doc) => ({
				id: doc.id,
				...doc.data(),
			}));

			// Get download URLs for each photo
			const photosWithUrls = await Promise.all(
				photos.map(async (photo) => {
					const imageRef = ref(storage, photo.storagePath);
					const imageUrl = await getDownloadURL(imageRef);
					return { ...photo, imageUrl };
				})
			);

			return photosWithUrls;
		} catch (error) {
			console.error("Error fetching photos:", error);
			throw error;
		}
	},
};
